import { FC, ReactNode, useEffect, useRef, useState } from 'react';

interface CountdownState {
  timeRemaining: number;
  timeRemainingSeconds: number;
}
interface CountdownProps {
  /**
   * epoch time in seconds
   */
  to: number;
  onTimeout?: () => void;
  children: (st: CountdownState) => ReactNode;
}

const getTimeRemaining = (to: number): number => {
  return Math.max(0, Math.floor(to - (new Date().getTime() / 1000)));
};

const Countdown: FC<CountdownProps> = ({to, onTimeout, children}) => {
  const [timeRemaining, setTimeRemaining] = useState(getTimeRemaining(to));
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => {
    timer.current = setInterval(() => {
      const timeRemaining = getTimeRemaining(to);
      setTimeRemaining(timeRemaining);
      if (onTimeout && timeRemaining <= 0) {
        onTimeout();
      }
    }, 1000);
    return () => {
      clearInterval(timer.current);
    };
  }, [to, onTimeout]);

  const timeRemainingSeconds =  new Date(0).setSeconds(timeRemaining) / 1000;

  return children({
    timeRemaining,
    timeRemainingSeconds,
  });
};

export { Countdown };
